import PermissionFilterParameters from "./permission-filter-parameters";
import PermissionOrderParameters from "./permission-order-parameters";
import PaginationParameters from "common/contracts/pagination-parameters";

export default class PermissionTemplateQuery {
  public filterParameters?: PermissionFilterParameters;
  public orderParameters?: PermissionOrderParameters;
  public paginationParameters?: PaginationParameters;

  constructor(
    filterParameters?: PermissionFilterParameters,
    orderParameters?: PermissionOrderParameters,
    paginationParameters?: PaginationParameters,
  ) {
    this.filterParameters = filterParameters;
    this.orderParameters = orderParameters;
    this.paginationParameters = paginationParameters;
  }

  public asSearchParams(): URLSearchParams {
    return new URLSearchParams([
      ...(this.filterParameters?.asSearchParams() ?? []),
      ...(this.orderParameters?.asSearchParams() ?? []),
      ...(this.paginationParameters?.asSearchParams() ?? [])
    ]);
  }

  public isEqualTo(other: PermissionTemplateQuery | undefined): boolean {
    if (!other) return false;

    const filtersEqual =
      (!this.filterParameters && !other.filterParameters) ||
      (this.filterParameters && other.filterParameters && this.filterParameters.isEqualTo(other.filterParameters));

    const orderEqual =
      (!this.orderParameters && !other.orderParameters) ||
      (this.orderParameters && other.orderParameters && this.orderParameters.isEqualTo(other.orderParameters));

    const paginationEqual =
      (!this.paginationParameters && !other.paginationParameters) ||
      (this.paginationParameters && other.paginationParameters && this.paginationParameters.isEqualTo(other.paginationParameters));

    return Boolean(filtersEqual && orderEqual && paginationEqual);
  }

  public cacheKey(): string {
    const params = this.asSearchParams();
    const sortedEntries = [...params.entries()].sort((a, b) => a[0].localeCompare(b[0]));
    return sortedEntries.map(([k, v]) => `${k}=${v}`).join("&");
  }
}
